import { Maybe } from '@crocodille/common';
import { useTranslation } from 'react-i18next';
import Image from '../../elements/image/image';

import React from 'react';
import styles from './product-special-offer.module.scss';

import specialOfferImage from '../../../../public/daily-bageta.jpg';

export interface ProductSpecialOfferProps {
  readonly isSpecialItem?: Maybe<boolean>;
}

/**
 * A card displaying product information in product listing.
 */
const ProductSpecialOffer: React.FC<
  React.PropsWithChildren<ProductSpecialOfferProps>
> = ({ isSpecialItem }) => {
  const { t } = useTranslation();

  return isSpecialItem ? (
    <div className={styles.imageContainer}>
      <Image
        className={styles.image}
        src={specialOfferImage}
        alt={t('cart.special_offer')}
        layout="fill"
      ></Image>
    </div>
  ) : null;
};

export default ProductSpecialOffer;
